import type { RouteRecordRaw } from 'vue-router';

const routes: Array<RouteRecordRaw> = [
  {
    path: '/home',
    name: 'Home',
    component: () => import('@/views/Home.vue'),
    meta: {
      title: 'route.home',
      keepAlive: true
    }
  },
  {
    path: '/order-detail',
    name: 'OrderDetail',
    component: () => import('@/views/OrderDetail.vue'),
    meta: {
      title: '预约详情'
    }
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    component: () => import('@/views/NotFound.vue'),
    meta: {
      title: 'error.notFound'
    }
  },
  {
    path: '/',
    name: 'index',
    component: () => import('@/views/index.vue'),
    meta: {
      title: 'index'
    }
  },
  {
    path: '/base-info',
    name: 'BaseInfo',
    component: () => import('@/views/BaseInfo.vue'),
    meta: {
      title: 'BaseInfo'
    }
  },
  {
    path: '/installation-position',
    name: 'InstallationPosition',
    component: () => import('@/views/InstallationPosition.vue'),
    meta: {
      title: 'InstallationPosition'
    }
  },
  {
    path: '/circuit-info',
    name: 'CircuitInfo',
    component: () => import('@/views/CircuitInfo.vue'),
    meta: {
      title: 'CircuitInfo'
    }
  },
  {
    path: '/order-success',
    name: 'OrderSuccess',
    component: () => import('@/views/OrderSuccess.vue'),
    meta: {
      title: 'OrderSuccess'
    }
  },
  {
    path: '/customer-review',
    name: 'CustomerReview',
    component: () => import('@/views/CustomerReview.vue'),
    meta: {
      title: 'CustomerReview'
    }
  }
];

export default routes; 